import { Switch, type SwitchRootProps } from '@chakra-ui/react';

type RiftboundSwitchProps = Omit<SwitchRootProps, 'colorPalette' | 'children'>;

/**
 * Checked thumb is the palette brown (`accent`). The track stays a wash of
 * that same brown so the knob still reads.
 */
export function RiftboundSwitch({ size = 'md', ...rest }: RiftboundSwitchProps) {
  return (
    <Switch.Root size={size} colorPalette="brandGold" {...rest}>
      <Switch.HiddenInput />
      <Switch.Control css={{ _checked: { bg: 'accent/32!' } }}>
        <Switch.Thumb css={{ _checked: { bg: 'accent!' } }} />
      </Switch.Control>
    </Switch.Root>
  );
}
